const enumValue = description => Object.freeze({toString: () => description});

export const EXECUTION = enumValue('EXECUTION');
export const NO_SORT = enumValue('');